import React, { createContext, useContext, useState } from 'react';
import { useFeatureGate } from 'src/debug/feature-gate/FeatureGatesContext';
import { FEATURE_GATE_UPLOAD_AND_PRINT_PROGRESSIVE_VALIDATION } from '../debug/feature-gate/gates';

export interface ClientValidationContextProps {
  isClientValidationEnabled: boolean;
  setClientValidation: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ClientValidationContext = createContext<ClientValidationContextProps>({
  isClientValidationEnabled: true,
  setClientValidation: () => undefined,
});

export interface ClientValidationProviderProps {
  children?: React.ReactNode;
}

export const ClientValidationProvider = ({ children }: ClientValidationProviderProps): React.ReactElement => {
  const { isEnabled: isProgressiveValidationEnabled } = useFeatureGate(
    FEATURE_GATE_UPLOAD_AND_PRINT_PROGRESSIVE_VALIDATION
  );
  const [isClientValidationEnabled, setIsClientValidationEnabled] = useState<boolean>(isProgressiveValidationEnabled());

  return (
    <ClientValidationContext.Provider
      value={{ isClientValidationEnabled, setClientValidation: setIsClientValidationEnabled }}
    >
      {children}
    </ClientValidationContext.Provider>
  );
};

export const useClientValidation = () => {
  return useContext(ClientValidationContext);
};
